import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/components/layout'
import utils from 'util';

import Antd from 'ant-design-vue/dist/antd.css';
import store from "@/store/index"                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
Vue.use(Router)
Vue.use(Antd);

export default new Router({
  mode: 'history',
  base: '/accim',
  routes: [
    {
      path: '/',
      component:()=>import("@/components/layout"),
      // eslint-disable-next-line no-sparse-arrays
      children: [{
        path: '/',
        component:()=>import("@/components/home"),      //首页
      },{
        path:'/Course',     //列表页
        component:()=>import("@/components/Course"),
        meta:{
          keepAlive: true //此页面需要缓存
        }
      },{
        // path:'/CourseDetail',
        path:'/',
        component:()=>import("@/components/CourseDetail"),
        children: [
          {
            path: "/courseInfo",
            // component: courseInfo,
            component:()=>import("@/components/courseInfo"),
          }, {
            path: "/catalog",
            // component: catalog,
            component:()=>import("@/components/catalog"),
          }, {
            path: "/answer",
            // component: answer,
            component:()=>import("@/components/answer"),
          }, {
            path: '/answerDetail',
            // component: answerDetail
            component:()=>import("@/components/answerDetail"),
          }, {
            path: '/answerNew',
            // component: answerNew,
            component:()=>import("@/components/answerNew"),
          }
        ]
      }, {
        path: "/catalogDetail",
        // component: catalogDetail,
        component:()=>import("@/components/catalogDetail"),
      },{
        path: "/test",
        // component: test
        component:()=>import("@/components/test"),
      }, {
        path: "/theoryexam",
        // component: theoryexam
        component:()=>import("@/components/theoryexam"),
      }, {
        path: "/prexam",
        // component: prexam,
        component:()=>import("@/components/prexam"),
      },{
        path:'/theoryTrain',
        // component:theoryTrain
        component:()=>import("@/components/theoryTrain"),
      },{
        path:'/startexam',
        // component:startexam
        component:()=>import("@/components/startexam"),
      },{
        path:'/watchexam',
        // component:watchexam
        component:()=>import("@/components/watchexam"),
      },
      {
        path:'/simulation',
        // component:simulation,
        component:()=>import("@/components/simulation"),
      },
      {
        path:'/simulationDetail',
        // component:simulationDetail,
        component:()=>import("@/components/simulationDetail"),
      },{
        path:'/register',
        // component:register
        component:()=>import("@/components/register"),
      },
      ,{
        path:'/forgetModal',
        // component:forgetModal
        component:()=>import("@/components/forgetModal"),
      }, {
        // path: '/mine',
        path: '/',
        // component: mine,
        component:()=>import("@/components/mine"),
        meta:{requireAuth:true},
        //进入个人中心之前，需要判断是否注册登录
        beforeEnter(to,from,next){
          if(localStorage.getItem("token")){
            next()
          }else{
            next({
              path: "/",
              query: {redirect: to.meta.redirect} 
            });
          }
        },
        children: [
          {
            path: '/basicInfo',
            component:()=>import("@/components/mine/basicInfo"),
            meta:{requireAuth:true},
          },
          {
            path: '/mysubject',
            component:()=>import("@/components/mine/mysubject"),
            meta:{requireAuth:true},
          },
          {
            path: '/myClass',
            component:()=>import("@/components/mine/myClass"),
            meta:{requireAuth:true},
          }, {
            path: '/myviedo',
            component:()=>import("@/components/mine/myviedo"),
            meta:{requireAuth:true},
          }, {
            path: '/manClass',
            component:()=>import("@/components/mine/manClass"),
            meta:{requireAuth:true},
          }
          , {
            path: '/manstudent',
            component:()=>import("@/components/mine/manstudent"),
            meta:{requireAuth:true},
          },
          {
            path: '/studyview',
            component:()=>import("@/components/mine/studyview"),
            meta:{requireAuth:true},
          },
          {
            path: '/myscore',
            component:()=>import("@/components/mine/myscore"),
            meta:{requireAuth:true},
          },
          {
            path: '/myPurge',
            component:()=>import("@/components/mine/myPurge"),
            meta:{requireAuth:true},
          },
          {
            path: '/myask',
            component:()=>import("@/components/mine/myask"),
            meta:{requireAuth:true},
          },{
            path: '/myreply',
            // component: myreply,
            component:()=>import("@/components/mine/myreply"),
            meta:{requireAuth:true},
          },
          {
            path: '/message',
            // component: message,
            component:()=>import("@/components/mine/message"),
            meta:{requireAuth:true},
          },
          {
            path: '/mystudent',
            // component: mystudent,
            component:()=>import("@/components/mine/mystudent"),
            meta:{requireAuth:true},
          }
        ]
      },
      {
        path:"*",
        component:()=>import("@/components/NotFound"),
      }
      ]


    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  
  // 导航守卫
  // 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
  beforeEach(to, from, next) {
    encryUrlOfRouter(to, from, next);
    if(store.state.isLogin==1){
      next("/")
    }else{
      next()
    };
    
  },
  //引入百度统计
  beforeEach(to, from, next){
    if (window._hmt) {
      if (to.path) {
        window._hmt.push(['_trackPageview', '/#' + to.fullPath])
      }
    }
    next()
  }
})
